/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import Compiled from '../compiled/components/live-region';

// ==============================
// Root Container
// ==============================

var LiveRegion = function LiveRegion(props) {
  return /*#__PURE__*/React.createElement(Compiled, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default LiveRegion;